'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addServerErrorsIntegration = addServerErrorsIntegration;
exports.applyServerErrorsIfAccepted = applyServerErrorsIfAccepted;
exports.handleServerErrors = handleServerErrors;

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = _auroraJavascriptUtils.log.getLogger('serverErrors');

var GLOBAL_ERROR_KEY = '*';
var INNER_MODEL_PATH_SEPARATOR = '.';
var FIELD_SPLIT_REGEXP = new RegExp('([a-zA-Z0-9]*)\\.(.*)');

function isInnerModelError(error) {
    return error.path.indexOf(INNER_MODEL_PATH_SEPARATOR) > 0;
}

function buildServerErrorsResponse(innerFieldErrors) {
    return {
        total: innerFieldErrors.length,
        _embedded: {
            errors: innerFieldErrors
        }
    };
}

function applyErrorsToInnerModel(model, innerModelsErrors) {
    // group by field
    var groupedInnerErrors = {};
    _underscore2.default.forEach(innerModelsErrors, function (innerModelError) {
        // normalize error path for inner model
        var matchResult = innerModelError.path.match(FIELD_SPLIT_REGEXP);
        var fieldName = matchResult[1];
        var innerFieldName = matchResult[2];
        var error = _underscore2.default.extend({}, innerModelError);
        error.path = innerFieldName;

        groupedInnerErrors[fieldName] = groupedInnerErrors[fieldName] || [];
        groupedInnerErrors[fieldName].push(error);
    });

    _underscore2.default.forEach(_underscore2.default.keys(groupedInnerErrors), function (fieldName) {
        model[fieldName].applyServerErrors(buildServerErrorsResponse(groupedInnerErrors[fieldName]));
    });
}

function addMethods(model) {
    /**
     * Apply server vnd/errors response to model. Transform errors to internal representation.
     * Reset old errors.
     * @param serverErrors
     */
    model.applyServerErrors = function applyServerErrors(serverErrors) {
        this.resetServerErrors();
        var normalizedServerErrors = {};
        var innerModelsErrors = [];

        if (!serverErrors || !(serverErrors._embedded && serverErrors._embedded.errors || serverErrors.errors)) {
            logger.warn('can\'t apply server errors - wrong format');
            return;
        }

        if (serverErrors._embedded && serverErrors._embedded.errors) {
            _underscore2.default.forEach(serverErrors._embedded.errors, function (error) {
                if (!error.path) {
                    normalizedServerErrors['*'] = normalizedServerErrors['*'] || [];
                    normalizedServerErrors['*'].push({
                        message: error.message,
                        details: error.details
                    });
                    return;
                }

                if (isInnerModelError(error)) {
                    innerModelsErrors.push(error);
                    return;
                }

                normalizedServerErrors[error.path] = normalizedServerErrors[error.path] || [];
                normalizedServerErrors[error.path].push({
                    message: error.message,
                    details: error.details
                });
            });
        }

        if (serverErrors.errors) {
            _underscore2.default.forEach(serverErrors.errors, function (error) {
                if (!error.field) {
                    normalizedServerErrors['*'] = normalizedServerErrors['*'] || [];
                    normalizedServerErrors['*'].push({
                        message: error.defaultMessage
                    });
                    return;
                }

                normalizedServerErrors[error.field] = normalizedServerErrors[error.field] || [];
                normalizedServerErrors[error.field].push({
                    message: error.defaultMessage
                });
            });
        }

        applyErrorsToInnerModel(model, innerModelsErrors);

        this._serverErrors = normalizedServerErrors;
    };

    /**
     * Reset current server errors (for fields and global)
     */
    model.resetServerErrors = function resetServerErrors() {
        this._serverErrors = {};
    };

    /**
     * return global server errors (*) or null if no errors exists
     */
    model.getGlobalErrors = function getGlobalErrors() {
        var result = this._serverErrors[GLOBAL_ERROR_KEY];
        return result ? result : null;
    };

    /**
     * return common (no field specified) error
     * if there is some field specified error return null
     */
    model.getCommonError = function getCommonError() {
        var _this = this;

        if (!this._links && !this._serverErrors) {
            return null;
        }

        if (this._links && Object.keys(this._links).some(function (key) {
            return _this._links[key] && _this._links[key].validationError !== null;
        })) {
            return null;
        }

        var commonErrors = Object.keys(this._serverErrors);
        if (!commonErrors.length) {
            return null;
        }
        return this._serverErrors[commonErrors[0]][0];
    };

    /**
     * reset server and validation errors
     */
    model.resetErrors = function resetErrors() {
        var _this2 = this;

        if (!this._links) {
            return;
        }
        Object.keys(this._links).forEach(function (key) {
            if (!_this2._links[key]) {
                return;
            }
            _this2._links[key].error = void 0;
        });
        this.resetServerErrors();
    };
}

function addServerErrorsIntegration(model) {

    model._serverErrors = {};

    addMethods(model);

    if (!model.getLink) {
        // `nestedreact` not applied so skip integration
        return;
    }

    // override getLink
    var originalGetLink = model.getLink;
    model.getLink = function getLink() {
        var fieldName = arguments[0];
        var result = originalGetLink.apply(this, arguments);

        var validationError = result.error; // force getter execution
        if (!validationError) {
            // add server errors
            var fieldServerErrors = this._serverErrors[fieldName];
            if (fieldServerErrors) {
                result.error = fieldServerErrors[0]; // can be multiply server errors
            }
        }

        return result;
    };

    model.on('change', function (changedModel) {
        var newAttributes = changedModel.attributes;
        var oldAttributes = changedModel.previousAttributes();
        var attributesNames = _underscore2.default.keys(newAttributes);

        _underscore2.default.forEach(attributesNames, function (attributeName) {
            var newAttribute = newAttributes[attributeName];
            var oldAttribute = oldAttributes[attributeName];
            if (oldAttribute !== newAttribute) {
                delete changedModel._serverErrors[attributeName];
                delete changedModel._serverErrors[GLOBAL_ERROR_KEY]; // global error reset after any field change
            }
        });
    });
}

/**
 * if mode support server errors - apply them
 * @param model - model instance
 * @param response - superAgent response
 */
function applyServerErrorsIfAccepted(model, response) {
    if (!model.applyServerErrors) {
        // integration not applied
        return;
    }

    if (response.status === 0) {
        model._serverErrors = { '*': [{ message: 'Unknown error' }] };
        return;
    }

    if (response.status === 401) {
        model._serverErrors = { '*': [{
                message: 'Unauthorized',
                details: response.body && response.body.error
            }] };
        return;
    }

    try {
        model.applyServerErrors(response.body);
    } catch (e) {
        logger.warn('Can\'t apply server error to model ' + e);
    }
}

/**
 * Add server errors to some model
 * @param model - model instance
 */
function handleServerErrors(model) {
    return function (response) {
        try {
            applyServerErrorsIfAccepted(model, response);
        } catch (err) {
            logger.warn('can\'t apply server error');
        }

        throw response; // keep old behaviour
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/serverErrors.js
// module id = 173
// module chunks = 118